export function cssLifecycleFactory() {
	return {
		bootstrap: async () => {},
		mount: async () => {},
		unmount: async () => {},
	};
}
